const buildSearchValuesText = ({
  propsToDisplay = []
} = {}, {
  search_term: searchTerm
} = {}) => propsToDisplay.reduce((acc, field, index) => {
  if (field && searchTerm) {
    if (index === 0) {
      acc.should.push({
        match: {
          pageBuilderIndexed: {
            query: searchTerm,
            fuzziness: 'AUTO',
            prefix_length: 3
          }
        }
      });
    }
    acc.must.push({
      match: {
        [field]: {
          query: searchTerm,
          fuzziness: 'AUTO',
          prefix_length: 3
        }
      }
    });
  }
  return acc;
}, {
  should: [],
  must: []
});
export default buildSearchValuesText;
//# sourceMappingURL=build-search-values-text.js.map